"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JoinTilesWrapper = exports.JoinTileLink = exports.JoinTileDescription = exports.JoinTileButton = exports.JoinMenuRoot = exports.JoinMenuIdkyLink = exports.JoinMenuBackdrop = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
const JoinMenuRoot = exports.JoinMenuRoot = (0, _mui.styled)('div')(({
  ownerState,
  theme
}) => ({
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${theme.palette.grey[100]}`,
  display: 'none',
  ...(ownerState.isVisible && {
    [theme.breakpoints.up('md')]: {
      boxShadow: _mui.SHADOW_LEVEL1,
      display: 'flex',
      flexDirection: 'column',
      left: 0,
      position: 'absolute',
      top: _constants.CSS_DESKTOP_INNER_HEIGHT,
      transition: `top ${_constants.CSS_HEIGHT_ANIMATION}`,
      width: '100%'
    }
  })
}));
const JoinTilesWrapper = exports.JoinTilesWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  [theme.breakpoints.up('md')]: {
    alignItems: 'center',
    borderBottom: `6px solid ${theme.palette.common.white}`,
    columnGap: 6,
    display: 'grid',
    gridAutoColumns: 'minmax(325px, 680px)',
    gridAutoFlow: 'column',
    gridTemplateRows: 325,
    justifyContent: 'center',
    overflow: 'hidden'
  }
}));
const JoinTileLink = exports.JoinTileLink = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  [theme.breakpoints.up('md')]: {
    color: theme.palette.common.white,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
    '&:hover, &:focus, &:active': {
      color: theme.palette.common.white,
      webkitTapHighlightColor: 'transparent'
    },
    '&:hover::before': {
      background: (0, _mui.alpha)(theme.palette.common.black, 0.3)
    },
    '&:hover': {
      '.joinTileTitle': {
        background: theme.palette.grey.A700,
        borderColor: 'transparent'
      }
    },
    '&::before': {
      background: 'transparent',
      content: '""',
      height: '100%',
      position: 'absolute',
      transition: '0.25s',
      width: '100%'
    },
    '& > img': {
      height: '100%',
      objectFit: 'cover',
      width: '100%'
    }
  }
}));
const JoinTileDescription = exports.JoinTileDescription = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  [theme.breakpoints.up('md')]: {
    fontWeight: theme.typography.fontWeightBold,
    margin: theme.spacing(0, 6),
    overflow: 'hidden',
    position: 'absolute',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    textShadow: theme.shadows[1],
    top: '50%',
    transform: 'translateY(-150%)',
    whiteSpace: 'nowrap'
  }
}));
const JoinTileButton = exports.JoinTileButton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  [theme.breakpoints.up('md')]: {
    display: '-webkit-box',
    left: '50%',
    maxWidth: 295,
    minWidth: 125,
    overflow: 'hidden',
    position: 'absolute',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    bottom: 60,
    transform: 'translate(-50%, 50%)',
    whiteSpace: 'nowrap'
  }
}));
const JoinMenuIdkyLink = exports.JoinMenuIdkyLink = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  [theme.breakpoints.up('md')]: {
    alignSelf: 'center',
    color: theme.palette.default.main,
    fontSize: '1.5rem',
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: '2.3rem',
    margin: theme.spacing(2, 0),
    textDecoration: 'underline',
    transition: '0.25s',
    '&:hover, &:focus, &:active': {
      color: theme.palette.default.light,
      webkitTapHighlightColor: 'transparent'
    }
  }
}));
const JoinMenuBackdrop = exports.JoinMenuBackdrop = (0, _mui.styled)(_mui.Backdrop)({
  position: 'absolute',
  zIndex: '-1',
  width: '100vw',
  height: '100vh'
});
